import { Button } from '@mui/material';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { NotePencil, NotePencilDesktop } from '../elements/svgIcon/outlined';

const PostModal = dynamic(
  () => import('../modal/training-module/post/PostModal')
);

export const CreatePostButtonMobile = () => {
  const [isOpenCreatePostModal, setIsOpenCreatePostModal] =
    useState<boolean>(false);
  return (
    <>
      <Button
        onClick={() => setIsOpenCreatePostModal(true)}
        className="!h-full !min-w-fit !max-w-[114px] !flex-grow !rounded-[6px] !border-[#009FE4] !bg-[#B1E7FF33] !p-[6px_16px] !text-xs !font-semibold !normal-case !leading-4 !tracking-normal"
        variant="outlined"
      >
        <NotePencil />
      </Button>
      {isOpenCreatePostModal && (
        <PostModal
          open={isOpenCreatePostModal}
          onClose={() => setIsOpenCreatePostModal(false)}
        />
      )}
    </>
  );
};

export const CreatePostButtonDesktop = () => {
  const [isOpenCreatePostModal, setIsOpenCreatePostModal] =
    useState<boolean>(false);
  return (
    <div>
      <Button
        onClick={() => setIsOpenCreatePostModal(true)}
        className="!flex !h-full !w-max !min-w-fit !max-w-[200px] !flex-grow !items-center !gap-x-1 !rounded-[6px] !border-[#3CACDD] !bg-[#3CACDD] !p-[6px_16px] !text-xs !font-semibold !normal-case !leading-4 !tracking-normal !text-[#FCFCFC] hover:!border-[#009FE4] hover:!bg-[#CFF0FF] hover:!text-Primary/Main"
        variant="outlined"
      >
        <NotePencilDesktop width={20} height={20} />
        <p className="leading-5">Đăng bài</p>
      </Button>
      {isOpenCreatePostModal && (
        <PostModal
          open={isOpenCreatePostModal}
          onClose={() => setIsOpenCreatePostModal(false)}
        />
      )}
    </div>
  );
};
